











import { defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationFollowings",
  components: { NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
});
